import { render, staticRenderFns } from "./kbjs.vue?vue&type=template&id=85f2d4ba&"
import script from "./kbjs.vue?vue&type=script&lang=js&"
export * from "./kbjs.vue?vue&type=script&lang=js&"
import style0 from "./kbjs.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports